/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {
	
	var $window = $(window);

	/**
	 * Callout Images/Browser
	 *
	 * @since 1.0.0
	 */
	var featureCallouts = function() {
		var $browsers = $( '.callout-browser-frame--has-zoom' );
		var browsers = [];

		if ( 0 === $browsers.length ) {
			return;
		}

		$browsers.each(function() {
			browsers.push({
				zoom: $(this).find( '.callout-browser-frame__zoom' ),
				offset: $(this).offset().top - 600
			});
		});

		function maybeShowZooms() {
			var y = $(this).scrollTop();

			_.each( browsers, function( browser ) {
				if ( y >= browser.offset ) {
					browser.zoom.addClass( 'is-shown' );
				}
			});
		}

		maybeShowZooms();

		$window.scroll(function() {
			maybeShowZooms();
		});
	};

	/**
	 * Fixed Navigation
	 *
	 * @since 1.0.0
	 */
	var fixedNav = function() {
		if ( $window.width() <= '992' ) {
			return;
		}

		if ( $( '.hero-wrap' ).length === 0 ) {
			return;
		}

		var $themeNav = $( '.fixed-nav-wrap' );

		new Waypoint.Inview({
			element: $( '.hero-wrap' )[0],
			entered: function() {
				$themeNav.removeClass( 'fixed-top' );
				$( 'body' ).css( 'padding-top', 0 );
			},
			exited: function() {
				$themeNav.addClass( 'fixed-top' );
				$( 'body' ).css( 'padding-top', 71 );
			},
			enter: function() {
				$themeNav.removeClass( 'fixed-top' );
				$( 'body' ).css( 'padding-top', 0 );
			},
			exit: function() {
				$themeNav.removeClass( 'fixed-top' );
				$( 'body' ).css( 'padding-top', 0 );
			}
		});
	};

	/**
	 * Features Slider
	 *
	 * @since 1.0.0
	 */
	var featuresSlider = function() {
		var $carousel = $( '#features-list' );

		if ( 0 === $carousel.length ) {
			return;
		}

		var windowWidth = $window.width();

		if ( windowWidth <= '992' ) {
			if ( ! $carousel.hasClass( 'slick-initialized' ) ) {
				$carousel.slick({
					arrows: false,
					dots: true,
					slidesToShow: 2,
					slidesToScroll: 2,
					adaptiveHeight: true,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});
			}
		} else {
			if ( $carousel.hasClass( 'slick-initialized' ) ) {
				$carousel.slick( 'unslick' );
			}
		} 
	}

	/**
	 * Showcase Slider
	 *
	 * @since 1.0.0
	 */
	var showcaseSlider = function() {
		var $carousel = $( '#theme-showcase' );

		if ( 0 === $carousel.length ) {
			return;
		}

		var windowWidth = $window.width();

		if ( windowWidth <= '992' ) {
			if ( ! $carousel.hasClass( 'slick-initialized' ) ) {
				$carousel.slick({
					arrows: false,
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1
				});
			}
		} else {
			if ( $carousel.hasClass( 'slick-initialized' ) ) {
				$carousel.slick( 'unslick' );
			}
		} 
	}

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {
		/**
		 * @see http://getbootstrap.com/javascript/#scrollspy
		 */
		$( 'body' ).scrollspy({ 
			target: '#fixed-nav' 
		});

		fixedNav();

		// browser frames and zooms
		featureCallouts();

		// customizations
		$( '.customization__slider' ).slick({
			asNavFor: '.customization__slider-nav',
			fade: true,
			cssEase: 'linear',
			arrows: false,
			responsive: [{
				breakpoint: 767,
				settings: {
					dots: true
				}
			}]
		});

		$( '.customization__slider-nav' ).slick({
			asNavFor: '.customization__slider',
			slidesToShow: 4,
			dots: false,
			focusOnSelect: true,
			arrows: false
		});

		// theme details theme preview slider
		$( '.theme-preview-wrap' ).slick({
			arrows: false,
			dots: false,
			centerMode: true,
			initialSlide: 0,
			variableWidth: true,
			focusOnSelect: true,
			infinite: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						variableWidth: false
					}
				}
			]
		});

		$( '.theme-preview-wrap' ).on( 'beforeChange', function(slick, currentSlide) {
			$( '.slick-current' ).removeClass( 'slick-focus' );
		});

		$( '.theme-preview-wrap' ).on( 'afterChange', function(slick, currentSlide) {
			$( '.slick-current' ).addClass( 'slick-focus' );
		});

		$( '.slick-current' ).addClass( 'slick-focus' );

		// Theme features.
		featuresSlider();
		showcaseSlider();

	});

	/**
	 * Bind to window resize.
	 *
	 * @since 1.0.0
	 */
	$window.resize(function() {
		featuresSlider();
		showcaseSlider();
		fixedNav();
	});

})( jQuery );
